import api, { make, Response } from '.'
import objectToQueryString from 'src/helpers/object-to-query-string'

type ResponseR14 = {
  report_data: {
    cost_center: string
    datetrunc: number
    justification: string
    reason: string
    request_id: number
    request_number: number
    request_ticket_receipt_number: number
    service: string
    status: string
    title: string
    total: number
    traveler: string
    user_id: number
  }[]
}

function isNull(value: string) {
  return ![undefined, null, ''].includes(value) ? value : 'NULL'
}

export function getReport142(props: any): Promise<Response<ResponseR14>> {
  const organization_id = props.organization_id
  const queryString = objectToQueryString({
    billing_type_id: isNull(props.billing_type_id),
    contract_id: isNull(props.contract_id),
    cost_center_id: isNull(props.cost_center_id),
    ended_on: props.ended_on ?? 0,
    organization_id,
    payment_resource_id: isNull(props.payment_resource_id),
    reason_id: isNull(props.reason_id),
    reference_id: isNull(props.reference_id),
    request_status: isNull(props.request_status),
    requester_id: isNull(props.requester_id),
    service_id: isNull(props.service_id),
    started_on: props.started_on ?? 0,
    target_id: isNull(props.target_id),
    traveler_id: isNull(props.traveler_id)
  })

  return make<ResponseR14>({
    axiosCall: api.get(
      `/organizations/${organization_id}/reports/142${queryString}`
    )
  })
}
